import { AdvisorsPaths } from '@src/components/sco/Advisors/paths'
import {
  ADVISOR_ENGAGEMENT_STATUS_ACTIVE,
  ADVISOR_ENGAGEMENT_STATUS_DRAFT,
  ADVISOR_ENGAGEMENT_STATUS_INVITED,
  ADVISOR_ENGAGEMENT_STATUS_SEARCHING,
} from '@src/constants/advisor-engagement-statuses'
import { IconType } from 'react-icons'
import { LuBriefcase, LuHandshake, LuRadar, LuSend, LuSquarePen } from 'react-icons/lu'

export type SeatsSectionKey = 'board' | 'invited' | 'searching' | 'drafts' | 'all'

/** Empty `statusKeys` means the API returns every founder-owned seat (including ended). */
export const SEAT_ALL_STATUS_KEYS: string[] = []

export type SeatsNavItem = {
  key: SeatsSectionKey
  title: string
  description: string
  href: string
  icon: IconType
  /** Statuses this view queries. */
  statusKeys: string[]
  countKey: SeatsSectionKey
  palette?: string
}

/**
 * My Advisors status views, in rail order (product L2).
 *
 * `board` is active engagements (Wil, team, accepted humans). The rest are
 * recruiting statuses. `all` is every founder-owned seat, including ended.
 */
export const seatsNavItems = (paths: AdvisorsPaths): SeatsNavItem[] => [
  {
    key: 'board',
    title: 'On your board',
    description: 'Everyone currently on your board — Wil, team, and accepted advisors.',
    href: paths.myAdvisors,
    icon: LuHandshake,
    statusKeys: [ADVISOR_ENGAGEMENT_STATUS_ACTIVE],
    countKey: 'board',
    palette: 'green',
  },
  {
    key: 'invited',
    title: 'Invited',
    description: 'Seats where you invited an advisor and are waiting on their answer.',
    href: paths.myAdvisorsInvited,
    icon: LuSend,
    statusKeys: [ADVISOR_ENGAGEMENT_STATUS_INVITED],
    countKey: 'invited',
    palette: 'orange',
  },
  {
    key: 'searching',
    title: 'Searching',
    description: 'Published seats actively matching candidates.',
    href: paths.myAdvisorsSearching,
    icon: LuRadar,
    statusKeys: [ADVISOR_ENGAGEMENT_STATUS_SEARCHING],
    countKey: 'searching',
    palette: 'blue',
  },
  {
    key: 'drafts',
    title: 'Drafts',
    description: 'Seats you have started but not published. Advisors are not matched yet.',
    href: paths.myAdvisorsDrafts,
    icon: LuSquarePen,
    statusKeys: [ADVISOR_ENGAGEMENT_STATUS_DRAFT],
    countKey: 'drafts',
    palette: 'gray',
  },
  {
    key: 'all',
    title: 'All',
    description: 'Every seat you own — on the board, invited, searching, drafts, and ended.',
    href: paths.myAdvisorsAll,
    icon: LuBriefcase,
    statusKeys: SEAT_ALL_STATUS_KEYS,
    countKey: 'all',
    palette: 'green',
  },
]
